import React from "react";
import "./ArticlePage.scss";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { Body, BodyContent, BodyHeading } from "@thrivetribe/mvf.ui.organisms.body";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import { useGetArticleQuery, useGetArticlesQuery } from "redux/contentApiSlice";
import { ArticleContent } from "ui/molecules/ArticleContent";
import { ThreeCards } from "ui/molecules/ThreeCards";
import RtkErrorMessage from "ui/organisms/Errors/RtkErrorMessage";
import { LoadingSpinner } from "@thrivetribe/mvf.ui.molecules.loading-spinner";

export const ArticlePage: React.FC = () => {
  const navigate = useNavigate();
  let { slug } = useParams();

  if (!slug) {
    throw new Error(`Unexpected rendering of the article page without slug parameter`);
  }

  const { data: article, isLoading: isArticleLoading, isError, error} = useGetArticleQuery(slug);
  const { data: articles, isLoading: isArticlesLoading} = useGetArticlesQuery({
    limit: 2,
    pageRequested: 1,
    excludeSlug: slug,
    contentOrderSelection: "Random",
  });

  if (isArticleLoading || isArticlesLoading) {
    return <LoadingSpinner fullscreen={false} />    
  }

  return (
    isError ?  ( 
      <RtkErrorMessage error={error} /> 
  ) : (
    <Body className="articles">
      {article && (
        <Helmet>
          <title>{`${article?.title} - MAN v FAT`}</title>
        </Helmet>
      )}
      <BodyHeading>
        <Button variant="text" onClick={() => navigate(-1)}>
          <ButtonArrow />
          Back
        </Button>
        <h1>{article?.title}</h1>
      </BodyHeading>

      <BodyContent>
        {article && (
          <ArticleContent
            introduction={article?.introduction}
            imgUrl={article?.asset.file.url}
            imgAlt={article?.asset.file.fileName}
            body={article?.body}
          />
        )}
        <div className="spacer" />
        <ThreeCards
          title="Level up"
          description="Want to take what you know to the next level? Dive into our articles, tips and guides on nutrition, physical activity, football and more."
          articles={articles ?? []}
        />
      </BodyContent>
    </Body>
  )
  );
};
